import { BasicComponent, ComponentChild, ComponentChildren } from "haxt";

import "./CardSection.scss";

export namespace CardSection {
	export type Options = {
		columns: 1 | 2 | 3;
		background?: "primary" | "secondary";
	};
	export type Props = {
		class?: JSX.HTMLAttributes["class"];
		style?: JSX.HTMLAttributes["style"];
		options: CardSection.Options;
		[BasicComponent.Children]?: ComponentChildren;
	};
}
export class CardSection extends BasicComponent<CardSection.Props> {
	protected override receivedProps(props: any, children: ComponentChild[]): void {
		super.receivedProps(props, children);
		// schedule an update to render with new props
		// TODO: better handling?
		this.update();
	}

	get cls() {
		return BasicComponent.mergeClasses(
			{
				CardSection: true,
				[`background-${this.props.options.background ?? "primary"}`]: true,
				[`columns-${this.props.options.columns}`]: true
			},
			this.props.class
		);
	}

	public render() {
		return (
			<div class={this.cls} style={this.props.style}>
				<div class="container">
					{this.children}
				</div>
			</div>
		);
	}
}
